import {Injectable} from "@angular/core";
import {createFeatureSelector, createSelector, Store} from "@ngrx/store";
import * as fromProviders from "../reducers/provider.reducer";
import {Observable} from "rxjs";
import {Provider} from "../../model/providers";


@Injectable()
export class ProvidersSelector {
  constructor(private readonly store: Store) {
  }

  getProvidersState = createFeatureSelector<fromProviders.State>('providers');

  getProviders(): Observable<Provider[]> {
    return this.store.select((createSelector(
      this.getProvidersState,
      (state: fromProviders.State) => state.currentProviders
    )));
  };


  getAllProviders(): Observable<Provider[]> {
    return this.store.select((createSelector(
      this.getProvidersState,
      (state: fromProviders.State) => {
        // Return currentProviders which already includes both saved and temporary providers
        // The reducer handles the combination logic properly
        return state.currentProviders;
      }
    )));
  };
}
